import React, { useRef } from "react";
import _ from 'lodash'
import { Menu } from "primereact/menu";
import useCensus from "../../hooks/useCensus";
import { IsBefore, IsToday, IsTodayOrBefore, IsTodayOrLater } from "../../utilities/DateHelper";
import { useHierarchyService } from "../../hooks/useHierarchyService";

const ProCensusActionMenu = ({data = null, performAction})=>{
    const {data:{filter}} = useCensus({ refreshTree: false })
    const {data:{selectedTreeNode}} = useHierarchyService();
    const node = selectedTreeNode;

    const menuRef = useRef(null);
    const getCensusMenuItems = ()=>{      
        let items = []       
            if(!_.isNull(data))
            {      
                if(_.isEqual(data.occupancyStatus, "UNOCCUPIED") && _.isEqual(data.reservationStatus, "RESERVED")){
                    items = IsTodayOrBefore(filter.date)?
                        [ { label: 'Cancel Reservation', icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_RESERVE", "")  } },
                        { label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]

                    :[ { label: 'Cancel Reservation', icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_RESERVE", "")  } }]
                }
                else if(_.isEqual(data.occupancyStatus, "OCCUPIED")){
                    const moveTitle = _.isEqual(data.occupantType.code, "CLIENT")?`Move ${data.occupantType.name}: ${data.client.firstName} ${data.client.lastName}` : `Move ${data.occupantType.name}: ${data.client.dependentName}`
                    items = IsTodayOrLater(filter.date)?
                    [   { label: 'Edit Assignment', icon: 'fa fa-user-edit' ,command:(e)=>{ performAction(node, data, "EDIT_ASSIGN", `Edit Assignment: ${node.label}`)  } },                                           
                        { label: `Move ${data.occupantType.name}`, icon: 'pi pi-sort-alt' ,command:(e)=>{ performAction(node, data, "MOVE", moveTitle)  } }]
                    
                    :[  { label: 'Edit Assignment', icon: 'fa fa-user-edit' ,command:(e)=>{ performAction(node,data, "EDIT_ASSIGN", `Edit Assignment: ${node.label}`)  } },
                    ]
                    data.latestAssignment && items.push({ label: 'Remove Assignment', icon: 'fa fa-trash' ,command:(e)=>{ performAction(node, data, "REMOVE_ASSIGN", "")  } })
                }
        }
        else{
            items = IsToday(filter.date)?
            [   { label: 'Reserve Bed', icon: 'fas fa-plus' ,command:(e)=>{ performAction(node, data, "RESERVE", `Reserve Bed: ${node.label}`)  } },
                { label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]

            :IsBefore(filter.date)? [{ label: 'Assign Bed', icon: 'fas fa-edit', command:(e)=>{ performAction(node, data, "ASSIGN", `Assign Bed: ${node.label}`) } }]
            :[{ label: 'Reserve Bed', icon: 'fas fa-plus' ,command:(e)=>{ performAction(node, data, "RESERVE", `Reserve Bed: ${node.label}`)  } }]
        }
        items.push({ label: 'View Bed Details', icon: 'fas fa-info-circle', command:(e)=>{ performAction(node, data, "VIEW_BED", `View Bed: ${node.label}`) } });
        items.push({ label: 'View Bed History', icon: 'fas fa-history', command:(e)=>{ performAction(node, data, "BED_HISTORY", `Bed History: ${node.label}`, 'bottom') } });
        !_.isNull(data) &&_.get(data.client, "id") && items.push({ label: 'View Client History', icon: 'fas fa-history', command:(e)=>{ performAction(node, data, "CLIENT_HISTORY", `Client Bed History: ${data.client.firstName} ${data.client.lastName}`, 'bottom') } });
        
        return items
    }
    return <div>
    <i className="pi pi-ellipsis-h" onClick={(event) => menuRef && menuRef.current.toggle(event)} style={{ position: 'relative', top: 2 }}></i> 
    <Menu  model={getCensusMenuItems()} popup ref={menuRef} />
</div>
}

export default ProCensusActionMenu;